module.exports = __webpack_public_path__ + "img/cover_photo.7832c9c9.jpg";